import React, { PropTypes } from 'react';
import { NitroHeading, NitroBadge, NitroDivider } from 'nitro-components';

import styled from 'styled-components';

const SummaryContainer = styled.section`
  margin-top: 30px;
`;

const SummarySection = ({ title, step, children }) => {
  const badge = step ? <NitroBadge variant="secondary" label={step} size={10} align="left" /> : null;

  return (
    <SummaryContainer>
      <NitroHeading label={title} variant="secondary" size="2" before={badge} />
      {children}
      <NitroDivider />
    </SummaryContainer>
  );
};

SummarySection.propTypes = {
  title: PropTypes.string,
  step: PropTypes.string,
  children: PropTypes.node,
  action: PropTypes.func,
  actionLabel: PropTypes.string
};

export default SummarySection;



// WEBPACK FOOTER //
// ./src/features/corporate-quote/workflow/components/SummarySection.js